//--- MAIN --- //
$(function () {
    $(".header-nav").parent().prepend('<button id="bg"></button>');

    nl_fn_responsive_menu();

    nl_fn_langs_menu();

    // nl_fn_hover_touch_unstick();

    $(document).on('scroll', function () {
        nl_fn_scroll_to();
    });

    nl_fn_cookie();

    //nl_fn_switch_content('.comp-tabs');
    nl_fn_switch_content('.restaurant-menu-inner');

    nl_fn_check_size();

    nl_fn_footer();
});

// --- COMPONENTS --- //
$(function () {

    fn_visual();
    fn_main_rooms_slider();

    fn_special_offfer();
    fn_special_offfers_side_slider();

    fn_comp_map();
    fn_show_more(".show-more",".block-more");
    fn_show_more(".show-more",".btns");

    fn_show_more_second('.show-more-info','.block-more','.equipment');
    fn_show_more_second('.show-more-info','.block-more','.max-occupancy');


    $('.parallax').parallax();
    // OFFER
    $(".openOffer").on("click", function () {
        $(this).parents(".hp-visual-offer").toggleClass("active");
    });
    if ($(window).width() > 768) {
        setTimeout(function () {$("#hp-offer").trigger('click')}, 2500);
    }
    // GOTO
    $(".goto").on("click", function (e) {
        e.preventDefault(e);
        var section = $(this).parents('#hp-visual').next();
        $('html, body').animate({
            scrollTop: section.offset().top - 45
        }, 500);
    });

    // --- CLOSE MAP INFO ---//
    $('.close-map-info').on('click', function (e) {
        e.preventDefault();
        $('.card').fadeOut(700);
    });

    // --- GALLERY ROOMS --- //
    $('.rooms-info-light-gallery').each(function(){
        var gallery_data = $(this).data('gallery');
        $(this).on('click', function(e) {
            e.preventDefault();
            $(this).lightGallery({
                dynamic: true,
                dynamicEl: gallery_data
            })
        });
    });
    /*fn_rooms_info_slick_slider();*/
    $('[data-ajax="sendForm"]').click(function () {
        $('#formResponseGood, #formResponseBad, #formResponseUsed').hide();
        var lng = $('html').attr('lang');
        var uri;
        if (lng != 'cs') {
            uri = '/' + lng + '/ajax/newsletter/';
        } else {
            uri = '/ajax/newsletter/';
        }
        $.ajax({
            url: uri,
            type: 'post',
            dataType: 'json',
            data: {
                mail: $('#newsletterMail').val()
            }
        }).done(function (data) {
            if (data.status == 'fail') {
                $('#formResponseGood, #formResponseUsed').hide();
                $('#formResponseBad').show();
            }
            if (data.status == 'existsMail') {
                $('#formResponseGood, #formResponseBad').hide();
                $('#formResponseUsed').show();
            }
            if (data.status == 'good') {
                $('#formResponseUsed, #formResponseBad').hide();
                $('#formResponseGood').show();
                setTimeout(function () {
                    $('#formResponseGood, #formResponseBad, #formResponseUsed').hide();
                    $('#newsletterMail').val('');
                }, 3000);
            }
        });
        return false;
    });
    if ($("#form").length) {
        setTimeout(function () {
            $("#form").append('<input name="antispam" value="antispam" type="hidden" />');
        }, 2500);
    }

    $('.show-more').click(function () {
        $(this).find('.text').toggle();
    });
});

// --- AFTER PAGE LOAD --- //
$(window).load(function(){
});